import { EmailTemplate } from '../../../../../../types/internal-api';

export interface EmailTemplatesFormState {
    templates: EmailTemplate[];
    emailTemplate: number;
    hasEmailTemplates: boolean;
}

export function emailTemplateFormState(
    templates: EmailTemplate[] = [],
    setDefaultSelectedTemplate = true
): EmailTemplatesFormState {
    const hasEmailTemplates = templates?.length > 0;

    let selectedTemplateId = 0;

    if (setDefaultSelectedTemplate) {
        const defaultTemplateId = hasEmailTemplates ? templates.find(t => t.isDefault)?.id : undefined;
        if (defaultTemplateId) {
            selectedTemplateId = defaultTemplateId;
        } else {
            selectedTemplateId = templates.length === 1 ? templates[0].id : 0;
        }
    }

    return {
        templates,
        emailTemplate: selectedTemplateId,
        hasEmailTemplates,
    };
}
